import { render, staticRenderFns } from "./mallConfig.vue?vue&type=template&id=77eca234&scoped=true&"
import script from "./mallConfig.vue?vue&type=script&lang=js&"
export * from "./mallConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77eca234",
  null
  
)

export default component.exports